import React from 'react'
import { defPath } from '../../config/defPath'
const Aid = ({ points }: any) => {
  return (
    <>
      <div className="ar__predictions__aid">
        <div className="ar__predictions__aid__box">
          <h2 className='subtitleSmall'>Sistema de puntos</h2>
          <div className="ar__predictions__aid__points">
            <div className="ar__predictions__aid__points__box">
              <h3 className='subtitle_black subtitle_black--big'>
                {points.equality?.points || 0} <span className='pts'>pts</span>
              </h3>
              <h2 className='subtitle_black subtitle_black--medium'>
                <span className="whiteShadow">{points.equality?.coins || 0}</span>
                <img className="ar__predictions__aid__points--icon" src={`${defPath}/assets/images/icons/coins.png`} alt="icono coins" />
              </h2>
              <p className='black_30'>
                Adivinar empate
              </p>
            </div>
            <div className="ar__predictions__aid__points__box">
              <h3 className='subtitle_black subtitle_black--big'>
                {points.winner?.points || 0} <span className='pts'>pts</span>
              </h3>
              <h2 className='subtitle_black subtitle_black--medium'>
                <span className="whiteShadow">{points.winner?.coins || 0}</span>
                <img className="ar__predictions__aid__points--icon" src={`${defPath}/assets/images/icons/coins.png`} alt="icono coins" />
              </h2>
              <p className='black_30'>
                Adivinar ganador
              </p>
            </div>
            <div className="ar__predictions__aid__points__box">
              <h3 className='subtitle_black subtitle_black--big'>
                {points.exactly?.points || 0} <span className='pts'>pts</span>
              </h3>
              <h2 className='subtitle_black subtitle_black--medium'>
                <span className="whiteShadow">{points.exactly?.coins || 0}</span>
                <img className="ar__predictions__aid__points--icon" src={`${defPath}/assets/images/icons/coins.png`} alt="icono coins" />
              </h2>
              <p className='black_30'>
                Adivinar marcador <br /> exacto
              </p>
            </div>
          </div>
          <div className="ar__predictions__aid__reminder">
            <h3 className='medium_45'>recuerda</h3>
            <p className='black_30'>
              Podrás ingresar tus pronósticos hasta 10 minutos antes del inicio de cada partido. El marcador que se tendrá en cuenta será el del resultado final en los 90 minutos o, en caso de tiempo extra, el resultado final en los 120 minutos. La serie de penaltis no será tenida en cuenta.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
export default Aid